import { ClearRounded } from "@mui/icons-material";
import {
	Box,
	Button,
	Dialog,
	DialogActions,
	DialogTitle,
	Divider,
	IconButton,
	InputLabel,
	Stack,
	TextField,
	Typography,
} from "@mui/material";
import { grey } from "@mui/material/colors";
import AddFiles from "components/EboStoreV4/CommonComponents/AddFiles/AddFiles";
import CustomTextField from "components/EboStoreV4/CommonComponents/CustomTextfield/CustomTextfield";
import RenderInputField from "components/EboStoreV4/CommonComponents/RenderInputFiled/RenderInputFiled";
import {
	addOrEditModelAction,
	autoUpdatestoreMainFieldsData,
	getColDefaultValue,
	insuranceTableColumns,
	insuranceTypeColumns,
	leaseDetails,
	storeBasicDetailsFields,
	storeInsuranceTableColumns,
	storeMainFields,
	storesLinkedTables,
	storeTypeDetails,
} from "components/EboStoreV4/data";
import { arrType, constraintsOptions } from "data/globalData";
import { inputTypes, statusOptions } from "data/pimData";
import { agreementData } from "data/supplierPageData";
import { useEffect, useState } from "react";

const AddOrEditModal = ({
	modal,
	setModal,
	type,
	defaultData,
	createDetailsApi,
	selectedStore,
	setSelectedStore,
	handleUpdateDetails,
	handleFileUploadDetails,
	handleGetStoreFiles,
}) => {
	const defFields = (() => {
		let obj = {};
		storeInsuranceTableColumns?.forEach((attr) => {
			obj[attr.key] = getColDefaultValue(attr);
		});
		return obj;
	})();
	const [insuranceDetails, setInsuranceDetails] = useState(type === addOrEditModelAction.UPDATE ? defaultData : defFields);
	const [agreementFile, setAgreementFile] = useState();

	const [allFiles, setAllFiles] = useState([]);

	const filtTypeOptions = {
		type: arrType,
		list: insuranceTypeColumns,
	};

	const handleCallback = (data) => {
		setAllFiles(data);
	};

	useEffect(() => {
		defaultData !== undefined &&
			handleGetStoreFiles(storesLinkedTables.store_insurance_details.key, defaultData?.id, handleCallback);
	}, []);
	const handleFileChange = (e) => {
		const file = e.target.files[0];
		setAgreementFile(file);
	};

	const handleAddFile = (data) => {
		setAllFiles([...allFiles, data]);
	};

	const handleModalclose = () => {
		setModal(false);
	};
	const handleInsuranceCallbackFun = (data) => {
		if (type === addOrEditModelAction.UPDATE) {
			let filtredData = selectedStore?.eboStoreInsuranceDetails.filter((data) => data.id !== insuranceDetails.id);
			let billerDetail = [...filtredData, insuranceDetails];
			setSelectedStore({ ...selectedStore, eboStoreInsuranceDetails: billerDetail });
		} else {
			let billerDetail = [...selectedStore?.eboStoreInsuranceDetails, data];
			setSelectedStore({ ...selectedStore, eboStoreInsuranceDetails: billerDetail });
		}
		setInsuranceDetails(defFields);
		setModal(false);
	};
	const handleFormSubmit = async (e) => {
		e.preventDefault();
		const filtredFiles = allFiles.filter((data) => data?.isNew);
		//this if for file upload
		let updatedData = await handleFileUploadDetails(
			filtredFiles,
			selectedStore.store_code,
			storesLinkedTables.store_biller_details.key
		);
		let updatedBiller = { ...insuranceDetails, ebo_store_v4_id: selectedStore.store_code, files: updatedData };
		if (type === addOrEditModelAction.UPDATE) {
			await handleUpdateDetails(storesLinkedTables.store_insurance_details.seqMethod, updatedBiller, handleInsuranceCallbackFun);
		} else {
			createDetailsApi(storesLinkedTables.store_insurance_details.seqMethod, updatedBiller, handleInsuranceCallbackFun);
		}
	};
	return (
		<Dialog maxWidth="md" fullWidth open={modal} onClose={handleModalclose} component="form" onSubmit={handleFormSubmit}>
			<Box p={2}>
				<Box display="flex" justifyContent="space-between" alignItems="center">
					<Typography variant="h6">{type === addOrEditModelAction.UPDATE ? "Update" : "Add"} Insurance</Typography>
					<Box>
						<IconButton onClick={handleModalclose}>
							<ClearRounded />
						</IconButton>
					</Box>
				</Box>
				<Stack spacing={1} width="100%">
					{" "}
					<Box display="flex" columnGap={"10px"} rowGap="10px" flexWrap="wrap" width="100%">
						{storeInsuranceTableColumns?.map((row) => {
							let options = {};
							if (row.key === "category") {
								options = filtTypeOptions;
							}
							return (
								<RenderInputField
									column={{ ...row, options }}
									data={insuranceDetails}
									setData={setInsuranceDetails}
									width="24%"
									selectOptObjName={"options"}
								/>
							);
						})}
						{/* File Input Field */}
						{/* <Stack sx={{ width: "35%" }} spacing={"3px"} height={"70px"}>
							<InputLabel sx={{ color: grey[600] }}>Agreement File</InputLabel>
							<TextField
								variant="outlined"
								size="small"
								type="file"
								value={agreementFile}
								onChange={handleFileChange}
								placeholder="Add Agreement file"
								required={true}
								fullWidth
							/>
						</Stack> */}
						<AddFiles
							columns={insuranceTableColumns}
							tableName={storesLinkedTables.store_insurance_details.key}
							rowId={defaultData?.id}
							handleAddFile={handleAddFile}
							files={allFiles}
							selectedStore={selectedStore}
						/>
					</Box>
				</Stack>

				<DialogActions sx={{ pt: 2 }}>
					<Button variant="outlined" sx={{ justifySelf: "center" }} onClick={handleModalclose}>
						Cancel
					</Button>
					<Button
						variant="contained"
						sx={{ justifySelf: "center" }}
						disabled={selectedStore.status === statusOptions.PUBLISHED.key}
						type="submit">
						{type === addOrEditModelAction.UPDATE ? "UPDATE" : "CREATE"}
					</Button>
				</DialogActions>
			</Box>
		</Dialog>
	);
};

export default AddOrEditModal;
